import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { PageContainer } from '../components/common/PageComponent.style';
import SignUpFormSNS from './SignUpFormSNS';
import PageTop from '../components/pageTop/PageTop';
import * as S from './SignUpForm.style';

const SignUpSNS = () => {
  const navigate = useNavigate();

  return (
    <PageContainer>
      <PageTop text="간편 회원가입" isMenu={false} hasSearch={false} />
      <S.Content>
        <TitleSection>
          <Title>마지막 단계에요.</Title>
          <Desc>약관동의 후 회원가입이 완료돼요.</Desc>
        </TitleSection>

        <SignUpFormSNS />
        <S.Login>
          이미 땅집고옥션 회원 이신가요?
          <S.LoginButton onClick={() => navigate('/login')}>
            로그인
          </S.LoginButton>
        </S.Login>
      </S.Content>
    </PageContainer>
  );
};

export default SignUpSNS;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

const Title = styled.div`
  align-self: stretch;
  color: #222;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.9px;
`;

const Desc = styled.div`
  align-self: stretch;

  color: #616161;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;
